// DO NOT EDIT -- generated from fs/services/dx-objects/properties.proto

import * as protobuf from '../../../google/protobuf';
import * as vars from '../../api/vars';

export namespace PropertiesPublic {

  export const GetAllPropertiesEndpoint = "/grpc/dx_objects.PropertiesPublic/GetAllProperties";
  /** Gets all properties. */
  export function GetAllProperties(sender: (req: GetAllPropertiesRequest, endpoint: string) => Promise<GetAllPropertiesResponse>, req: GetAllPropertiesRequest): { promise: () => Promise<GetAllPropertiesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllPropertiesEndpoint),
      endpoint: GetAllPropertiesEndpoint
    };
  }

  export const GetPropertyEndpoint = "/grpc/dx_objects.PropertiesPublic/GetProperty";
  /** Gets a specific property at the current version. */
  export function GetProperty(sender: (req: GetPropertyRequest, endpoint: string) => Promise<GetPropertyResponse>, req: GetPropertyRequest): { promise: () => Promise<GetPropertyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPropertyEndpoint),
      endpoint: GetPropertyEndpoint
    };
  }

  export const SilenceIssueEndpoint = "/grpc/dx_objects.PropertiesPublic/SilenceIssue";
  /** Silences an issue for a property. */
  export function SilenceIssue(sender: (req: PropertyIssueSilenceRequest, endpoint: string) => Promise<PropertyIssueSilenceResponse>, req: PropertyIssueSilenceRequest): { promise: () => Promise<PropertyIssueSilenceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SilenceIssueEndpoint),
      endpoint: SilenceIssueEndpoint
    };
  }

  export const UnSilenceIssueEndpoint = "/grpc/dx_objects.PropertiesPublic/UnSilenceIssue";
  /** Un-silences an issue for a property. */
  export function UnSilenceIssue(sender: (req: PropertyIssueUnSilenceRequest, endpoint: string) => Promise<PropertyIssueUnSilenceResponse>, req: PropertyIssueUnSilenceRequest): { promise: () => Promise<PropertyIssueUnSilenceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnSilenceIssueEndpoint),
      endpoint: UnSilenceIssueEndpoint
    };
  }
}

export interface PropertyDetail {
  /** Uses the standard "<scope>_<name>_<type>" format. */
  id: string;
  scope: vars.Scope;
  name: string;
  type: vars.Type;
  archived: boolean;
}

export interface GetAllPropertiesRequest {
  orgId: string;
  /** If true, archived properties will also be returned. */
  includeArchived: boolean;
}

export interface GetAllPropertiesResponse {
  properties: PropertyDetail[];
}

export interface GetPropertyRequest {
  orgId: string;
  /** Uses the standard "<scope>_<name>_<type>" format. */
  propertyId: string;
}

export interface GetPropertyResponse {
  property: PropertyDetail | null;
}

export interface PropertyIssueSilence {
  id: string;
  /** Uses the standard "<scope>_<name>_<type>" format. */
  propertyId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface PropertyIssueSilenceRequest {
  orgId: string;
  /** Uses the standard "<scope>_<name>_<type>" format. */
  propertyId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface PropertyIssueSilenceResponse {
  issueSilence: PropertyIssueSilence | null;
}

export interface PropertyIssueUnSilenceRequest {
  orgId: string;
  /** Uses the standard "<scope>_<name>_<type>" format. */
  propertyId: string;
  issueSilenceId: string;
}

export interface PropertyIssueUnSilenceResponse {
  issueSilenceId: string;
  /** Uses the standard "<scope>_<name>_<type>" format. */
  propertyId: string;
}
